/**
 * Labstep
 *
 * @module core/Text/Small
 * @desc TextSmall (Dates etc)
 */

import React from 'react';
import styles from './styles.module.scss';

export const TextSmall: RFC = ({ children }) => (
  <small className={styles.textSmall}>{children}</small>
);
